import { Body } from 'copilot-design-system';

import { AnimatedDots } from 'src/components/chat/inner-channel/channel-content/AnimatedDots';

const containerClasses = 'flex items-center';

interface ChannelTypingIndicatorProps {
  typingUsers: Array<{
    user?: {
      id?: string;
      name?: string;
    };
  }>;
}

export const ChannelTypingIndicator = ({
  typingUsers,
}: ChannelTypingIndicatorProps) => {
  if (!typingUsers || typingUsers.length === 0) {
    return null;
  }

  return (
    <>
      {typingUsers.length === 1 && (
        <div className={containerClasses}>
          <Body size="sm" tag="div">
            {`${typingUsers.at(0)?.user?.name}`} is typing
          </Body>
          &nbsp;
          <AnimatedDots />
        </div>
      )}

      {typingUsers.length > 1 && (
        <div className={containerClasses}>
          <Body size="sm" tag="div">
            Multiple people are typing
          </Body>
          &nbsp;
          <AnimatedDots />
        </div>
      )}
    </>
  );
};
